import React, { useState, useEffect } from "react";
import GlobalStudentActivityList from "../../../pages/common/globalstudentactivitylist"

export default function Activities({ slug, show }) {
  return (
      <GlobalStudentActivityList slug={slug} isStudent={false} show={show} />
  );
}
